import { ReactNode } from 'react';
import { Api } from 'vopay';
import ApiProvider from './Api/Api.provider';
import ToastProvider from './Toast/Toast.provider';
import AlertDialogProvider from './AlertDialog/AlertDialog.provider';
import DialogProvider from './Dialog/Dialog.provider';
import ELinxConnectProvider from '#shared/components/ELinx/ELinxConnect.provider';

export type SharedProvidersProps = {
  api: Api;
  children: ReactNode;
};

// The one wrapper a host mounts to give shared code its services. The api instance is host-injected;
// toasts, alert dialogs and dialogs are shared's own UI (rendered here), so hosts may consume shared's
// useToast()/useAlertDialog()/useDialog() instead of keeping their own. ELinxConnectProvider is composed
// in innermost so the single eLinx overlay (ID-12903) has Api/Toast, and useELinxConnect works in any
// host without extra wiring.
//
// The blocking loader (LoaderProvider) is deliberately not composed here; it must mount above anything
// that fetches, while this wrapper stays innermost. eLinx's embed-url hook uses it, and the host mounts
// LoaderProvider above this wrapper, so it is in scope here.
//
// Nested explicitly rather than through a composeProviders([...]) helper (the pattern the micro-apps use):
// those helpers only compose prop-less providers, and ApiProvider needs the host's `api` prop.
export default function SharedProviders({ api, children }: SharedProvidersProps) {
  return (
    <ApiProvider api={api}>
      <ToastProvider>
        <AlertDialogProvider>
          <DialogProvider>
            <ELinxConnectProvider>{children}</ELinxConnectProvider>
          </DialogProvider>
        </AlertDialogProvider>
      </ToastProvider>
    </ApiProvider>
  );
}
